import * as React from "react";

const CENTaxonomyArrowUp: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.25037 14.812C5.25037 14.5241 5.36023 14.2361 5.57996 14.0167L11.205 8.39172C11.6444 7.95227 12.3563 7.95227 12.7958 8.39172L18.4208 14.0167C18.8602 14.4562 18.8602 15.1681 18.4208 15.6075C17.9813 16.047 17.2694 16.047 16.83 15.6075L12.0004 10.7778L7.1699 15.6082C6.73044 16.0477 6.01853 16.0477 5.57908 15.6082C5.35935 15.3885 5.25037 15.1002 5.25037 14.812Z"
                fill="#262525"
            />
        </svg>
    );
};

export default React.memo(CENTaxonomyArrowUp);
